import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { CoreConfigService } from '../../services/config/core-config.service';


@Component({
    selector: 'zx-login-modal',
    templateUrl: './login-modal.component.html',
    styleUrls: ['./login-modal.component.css'],
})
export class LoginModalComponent implements OnInit {
    validateForm: FormGroup;
    authenticationError: boolean = false;
    qrcodeUrl: any
    qrcodeLogin: boolean = false;
    errorMessage: string;
    private _loginHandle: Function;
    private host: string;
    private routerUrl: string;
	private _defaultAppTitle = "登录系统";

    
	@Input("app-title") appTitle: string;
    @Input("app-logo") appLogo: string;
    
    @Input() set loginHandle(value: Function) {
        this._loginHandle = value;
    }

    @Input() set isWechatLogin (value) {
        this.qrcodeLogin = value;
    }

    @Input() set httpErrorResponse (value) {
        if (value) {
            this.errorMessage = value.error.error_description;
        }
    }

    @Input() set currentRouter(value) {
        if (value) {
            this.routerUrl = value;
        }
    }

    constructor(
        private formBuilder: FormBuilder,
        private modalSubject: NzModalRef,
        private sanitizer: DomSanitizer,
		private titleService: Title,
		private configService: CoreConfigService,
        private activatedRoute: ActivatedRoute
    ) {
    }

    ngOnInit() {
        this.host = location.host;
		const config = this.configService.loginPage || {};

		this.appTitle = this.appTitle || config.appTitle || this._defaultAppTitle;
        this.titleService.setTitle(this.appTitle);
        
        this.qrcodeUrl = this.sanitizer.bypassSecurityTrustResourceUrl("/uaa/open-auth/weixin/auth-temp-key?href=data:text/css;base64,LmltcG93ZXJCb3gge2NvbG9yOiNmZmZ9Ci5pbXBvd2VyQm94IC5xcmNvZGUge3dpZHRoOiAyMTBweDtib3JkZXI6IDA7cGFkZGluZzogMjBweDttYXJnaW4tdG9wOiAwOyBiYWNrZ3JvdW5kOiAjZWVlO30KLmltcG93ZXJCb3ggLnRpdGxlIHtkaXNwbGF5Om5vbmV9Ci5wYW5lbENvbnRlbnQge21hcmdpbi10b3A6MjBweH0KLmltcG93ZXJCb3ggLmluZm97ZGlzcGxheTpub25lfQ==&authType=WEIXIN_WEB_APP&scope=snsapi_login&redirectUrl=https://" + this.host + "/gmp");
        this.initForm();
    }


    initForm() {
        this.validateForm = this.formBuilder.group({
            username: [null, [Validators.required]],
            password: [null, [Validators.required]],
            rememberMe: [true],
        });
    }

    logout() {
        this.validateForm.reset();
        this.authenticationError = false;
        this.modalSubject.triggerCancel();
    }

    login() {
        for (const i in this.validateForm.controls) {
            this.validateForm.controls[i].markAsDirty();
        }
        if (this.validateForm.status != 'VALID') return false;
        if (this._loginHandle) {
            this._loginHandle(this.validateForm.value).then(() => {
                this.authenticationError = false;
                this.modalSubject.triggerOk();
            }).catch(() => {
                this.authenticationError = true;
            });
        }
    }
}
